export default {
  histories: [],
  isHistoriesFetched: false,
  isFetchingHistories: false,
  historiesLoadedLength: null,
}